import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Icon, Form, Input } from "antd";

import config from "../../../config";
import logo from "../../../assets/logo_horizontal_rehab.png";

import "../style.css";

class ForgotPass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      message: "",
    };
  }

  onKeyPress = (e) => {
    if (e.keyCode === 13) {
      this.handle_forgot_pass();
    }
  };

  handle_forgot_pass = async () => {
    if (
      this.state.email.length < 6 ||
      !this.state.email.includes("@") ||
      !this.state.email.includes(".")
    ) {
      this.setState({ message: "Please enter a valid email address" });
      return;
    }

    let url = `${config.api_url}/api/v1/appforgotpassword/`;
    let options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: this.state.email }),
    };
    let ret = await fetch(url, options);
    ret = await ret.json();
    console.log("token2 is", ret);
    window.location = "/";
    // this.setState({ token2: ret.token2 });
  };
  render() {
    return (
      <div className="bg">
        <div className="login-card">
          <Form className="login-form">
            <img
              className="sign-in-logo"
              src={logo}
              alt="Ascension Training Platform"
            />
            <h2>Forgot your password?</h2>
            <h5>Enter your email and we'll send you a reset link</h5>

            {/*<Label>Email Address</Label>*/}
            <Input
              type="text"
              prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="email"
              onChange={(r) =>
                this.setState({ email: r.target.value, message: "" })
              }
              onKeyDown={this.onKeyPress}
            />

            <p className="small error">{this.state.message}</p>

            <Button
              color="primary"
              onClick={this.handle_forgot_pass}
              onKeyDown={this.onKeyPress}
            >
              Send Reset Link
            </Button>
          </Form>
          <p className="mt-5">
            Already have an account? <Link to="/">Sign In</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default ForgotPass;
